export enum DataEventType {
    clickIcon,
    dblClickIcon
}
